import React from 'react';
import PropTypes from 'prop-types';
import GameContextPlayerDuelDataContainer from '../../PlayerDuel/containers/GameContextPlayerDuelDataContainer';
import TopPerformersDataContainer from '../../TopPerformers/containers/TopPerformersDataContainer';
import { TopPerformersWrapper } from '../GameContext.style';
import ProbablePitchersDataContainer from '../../ProbablePitchers/ProbablePitchersContainer';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks';
import { GAME_CONTEXT_BREAKPOINTS } from '../../themes/breakpoints';
const { LG_MAX, MOBILE } = GAME_CONTEXT_BREAKPOINTS;
const HEADSHOT_SIZES = {
    LIVE: {
        DEFAULT: '88px',
        MOBILE: '48px'
    },
    FINAL: {
        DEFAULT: 88,
        MOBILE: 48
    }
};
export const GameDetailsLayer = ({ gameState }) => {
    const useDuelDisplay = useMedia({ maxWidth: LG_MAX });
    const isMobile = useMedia({ maxWidth: MOBILE });
    return (
        <>
            {gameState === 'P'
                ? <ProbablePitchersDataContainer duelDisplay={useDuelDisplay}/>
                : (gameState === 'L'
                    ? <GameContextPlayerDuelDataContainer
                        showUpcomingBatters={false}
                        stacked={true}
                        headshotWidth={HEADSHOT_SIZES.LIVE[isMobile ? 'MOBILE' : 'DEFAULT']}
                        isMobile={isMobile}
                    />
                    : <TopPerformersWrapper>
                        <TopPerformersDataContainer headshotSize={HEADSHOT_SIZES.FINAL[isMobile ? 'MOBILE' : 'DEFAULT']} showPlayerStories={true} condensedStatLine={true}/>
                    </TopPerformersWrapper>)
            }
        </>
    );
};

GameDetailsLayer.propTypes = {
    gameState: PropTypes.string
};
